import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MovimentoProvider } from "@vertex/ui/movimento";
import { App } from "./app";
import { ToastProvider } from "./lib/toast";
import "./styles/index.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root não existe no index.html");

createRoot(el).render(
  <StrictMode>
    {/* VOS Movimento: o mesmo provider do web (LazyMotion + reduzir movimento
        do sistema). O arraste e o layout chegam depois da primeira pintura. */}
    <MovimentoProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </MovimentoProvider>
  </StrictMode>,
);

/**
 * Banco local: aberto DEPOIS do primeiro paint e por import dinâmico. O wasm
 * tem ~400 KB e a tela de login não depende dele — pagar isso no caminho
 * crítico trocaria 200 ms de cold start por mais de um segundo, e o operador
 * veria tela branca enquanto um banco que ele ainda não vai usar carrega.
 *
 * `requestIdleCallback` quando existe; o Chromium 109 do Win7 tem, mas o
 * fallback cobre WebView que não implemente.
 */
const abreBanco = () => {
  void import("./storage").then(async (m) => {
    /* Handle de diagnóstico: é o que o `scripts/opfs-smoke.mjs` usa pra provar
       persistência real depois de um reload. Custa duas referências. */
    Object.assign(window, { __vosOpenStore: m.openStore, __vosStorageStatus: m.storageStatus });
    try {
      await m.openStore();
    } catch {
      /* Sem banco local o terminal ainda vende ONLINE — que é todo o escopo de
         hoje. O aviso de "offline indisponível" sai da `storageStatus`. */
    }
  });
};
if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(abreBanco, { timeout: 2000 });
else window.setTimeout(abreBanco, 300);
